// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-sms-list-item-message .mobile-subdata {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: normal;
}
.fi-sms-list-item-message .message-to-mobile {
  margin-right: 5px;
}
.fi-sms-list-item-message .message-to-mobile .contact:not(:last-child) {
  margin-right: 5px;
}
.fi-sms-list-item-message .message-to-mobile .contact:not(:last-child):after {
  content: ",";
}`, "",{"version":3,"sources":["webpack://./Source/app/sms/sms-list/list-sms-message/list-sms-message.component.scss"],"names":[],"mappings":"AACI;EACI,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAAR;AAGI;EACI,iBAAA;AADR;AAIY;EACI,iBAAA;AAFhB;AAIgB;EACI,YAAA;AAFpB","sourcesContent":[".fi-sms-list-item-message {\r\n    .mobile-subdata {\r\n        max-width: 100%;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        white-space: nowrap;\r\n        font-weight: normal;\r\n    }\r\n\r\n    .message-to-mobile {\r\n        margin-right: 5px;\r\n\r\n        .contact {\r\n            &:not(:last-child) {\r\n                margin-right: 5px;\r\n\r\n                &:after {\r\n                    content: ',';\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
